import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';

import ACHIEVEMENT_IMAGES from '../../../../../images/achievements';
import { normalizeAchievementsStrings } from '../../Utils';

import styles from './CardGridUnlocked.css';


function CardGridUnlocked({ id, index, onClick }) {
  const handleClick = useCallback(() => {
    onClick(index);
  }, [onClick, index]);

  if (!id) {
    return null;
  }

  return (
    <div
      key={id}
      className={styles.container}
      data-cy="container_card"
      onClick={handleClick}
    >
      <div className={styles.imgContainer}>
        <div className={styles.background}>
          <img
            alt=""
            className={styles.trophiesImage}
            data-cy="container_img"
            src={ACHIEVEMENT_IMAGES[id.toLowerCase()]}
          />
        </div>
      </div>

      <p className={styles.title} data-cy="trophycard_title">
        {translate(normalizeAchievementsStrings(id.toLowerCase(), 'title'))}
      </p>
    </div>
  );
}

CardGridUnlocked.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CardGridUnlocked;
